import { Injectable } from '@angular/core';
import { buttonsFirst, buttons, buttonsLast } from '../botones';

@Injectable({ providedIn: 'root' })
export class StepsFacturas {
  constructor() {
    this.crear();
  }

  crear() {
    return [
      {
        attachTo: {
          element: '.step_100',
          on: 'bottom' as const,
        },
        title: 'FACTURAS',
        text: `
            En esta página puede encontrar toda la información relativa a las facturas que le hemos emitido.
        `,
        buttons: buttonsFirst,
      },
      {
        attachTo: {
          element: '.step_200',
          on: 'bottom' as const,
        },
        title: 'EXPORTAR',
        text: `
            Puede exportar los registros en formato CSV (Hoja de cálculo) por si desea importarlos en su programa de gestión o realizar cálculos sobre ellos con una hoja de cálculo como Microsoft Excel, Google Sheets, LibreOffice, ... 
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_300',
          on: 'bottom' as const,
        },
        title: 'QUITAR FILTRO',
        text: `
            Si existe algún filtro aplicado sobre los registros puede quitarlo pulsando aquí.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_400',
          on: 'bottom' as const,
        },
        title: 'COLUMNAS',
        text: `
            Al pulsar sobre cada columna se ordenarán los registros de forma ascendente o descendente.  También puede reordenar las columnas arrastrándolas a la posición deseada manteniendo pulsado el botón del ratón.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.p-datatable-tbody',
          on: 'bottom' as const,
        },
        title: 'DATOS',
        text: `
            En la parte central de la tabla tendrá acceso a los registros.  En la última columna se muestran las acciones que puede realizar sobre cada registro.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.p-paginator',
          on: 'bottom' as const,
        },
        title: 'PAGINADOR',
        text: `
            Puede cambiar de página utilizando el paginador y el número de registros mostrados en cada página.
        `,
        buttons: buttonsLast,
      },
    ];
  }
}
